export default class Anchor {
  constructor(config) {
    this.config = {
      linkSelector: 'a[href^="#"]',
      scrollToSelector: '[data-scroll-to]',
      toTopSelector: '[data-action="scroll-to-top"]',
      anchorSelector: '[data-anchor="%s"]',
      offset: 0,
      beforeScrollToElement: null,
      afterScrollToElement: null,
      ...config,
    };

    this.init();
    this.events();
  }

  events() {
    document.addEventListener('click', (e) => {
      if (e.target.closest(this.config.linkSelector)) {
        this.onAnchorLinkClick(e);
        return;
      }

      if (e.target.closest(this.config.scrollToSelector)) {
        this.onScrollToClick(e);
        return;
      }

      if (e.target.closest(this.config.toTopSelector)) {
        this.onScrollToTopClick();
        e.preventDefault();
        return;
      }
    });
  }

  init() {
    const { hash } = window.location;
    if (hash && hash.length > 1) {
      this.scrollToElement(hash.replace('#', ''));
    }
  }

  onAnchorLinkClick(e) {
    const a = e.target.closest(this.config.linkSelector);
    if (!a) return;
    const { pathname } = window.location;
    const hash = a.getAttribute('href');
    e.preventDefault();
    if (window.location.hash !== hash) {
      history.pushState(null, null, `${pathname}${hash}`);
    }
    if (hash && hash.length > 1) {
      this.scrollToElement(hash.replace('#', ''));
    }
  }

  onScrollToClick(e) {
    const el = e.target.closest(this.config.scrollToSelector);
    const hash = el?.dataset?.scrollTo;
    if (hash && hash.length > 1) {
      this.scrollToElement(hash.replace('#', ''));
    }
  }

  onScrollToTopClick() {
    Anchor.scrollBy(-window.pageYOffset);
  }

  scrollToElement(selector) {
    const { offset, anchorSelector, beforeScrollToElement, afterScrollToElement } = this.config;
    const sel = anchorSelector.replace('%s', selector);
    const element = document.querySelector(sel);

    if (element) {
      if (typeof beforeScrollToElement === 'function') {
        beforeScrollToElement(element);
      }

      const rect = element.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const top = rect.top + scrollTop - offset;

      window.scrollTo({
        top: top,
        behavior: 'smooth',
      });

      if (typeof afterScrollToElement === 'function') {
        setTimeout(() => afterScrollToElement(element), 600);
      }
    }
  }

  static scrollBy(offset) {
    window.scrollBy({
      behavior: 'smooth',
      left: 0,
      top: offset,
    });
  }
}
